// extracted by mini-css-extract-plugin
module.exports = {"main":"viewAdminModule_main__rQwxr","container":"viewAdminModule_container__RODyk"};